import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "sonner";
import { importExpensesConfirm } from "../services";

export function useImportExpensesConfirm() {
	const queryClient = useQueryClient();

	return useMutation<void, AxiosError<{ message?: string }>, FormData>({
		mutationFn: (formData) => importExpensesConfirm(formData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["expenses"] });
			queryClient.invalidateQueries({ queryKey: ["expensesReports"] });
			queryClient.invalidateQueries({ queryKey: ["expensesHistory"] });

			toast(
				ToastCustom({
					description: "Despesas importadas com sucesso.",
					title: "Importação concluída",
					variant: "success",
				})
			);
		},
		onError: (error) => {
			const message =
				error.response?.data?.message ??
				"Erro ao confirmar a importação de despesas.";

			toast(
				ToastCustom({
					description: message,
					title: "Erro na importação",
					variant: "error",
				})
			);
		},
	});
}
